exports = module.exports = require("../../../../employee/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dropdown {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box; }\n\ndiv#menu- > div[role=\"document\"] {\n  overflow-y: scroll;\n  max-height: 40% !important; }\n  div#menu- > div[role=\"document\"] ul li {\n    white-space: normal !important;\n    word-wrap: break-word !important;\n    height: auto; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/components/MultiSelectDropdown/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/components/MultiSelectDropdown/index.css
// module chunks = 504